"use client";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { C_LOC_COOKIE, C_2LOC_COOKIE } from "../../../../constants/cookies.js";
import { SEARCH_SERVICE_PROVIDERS } from "../../../../constants/grs.js";
import { DELIVERY_LOCATION_POSTAL_CODE_LOCAL_STORAGE_KEY } from "../../../../constants/localStorage.js";
import Cookie from "js-cookie";
import { useAgent } from "../../../../utils/agent/AgentProvider.js";
import { isBD, isCABD } from "../../../../utils/businessType.lib.js";
import { AKAMAI_COOKIE } from "../../../../utils/constants.js";
import { AKAMAI_ZIP_CODE_LOCALE_VALIDATION_CONFIGURATION } from "../../../../utils/validations/akamaiZipCode.js";
import { DELIVERY_LOCATION_LOCALE_VALIDATION_CONFIGURATION, validateDeliveryLocation } from "../../../../utils/validations/deliveryLocations.js";
import { useState, useEffect } from "react";
import { Tooltip, Button } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import "../../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../../Chrome/BrowseContext/hook.js";
import { LEGACY_COOKIE_WC_BD_ZIP_ORIGINAL, LEGACY_COOKIE_WC_BD_LOC } from "../../../Chrome/BrowseContext/constants.js";
import { DeliveryLocationDrawerUI } from "../../DeliveryLocationDrawer/DeliveryLocationDrawerUI/index.js";
import { LocationSelectorButton } from "../../LocationSelector/index.js";
import { useLocalStorage } from "../../../../hooks/useLocalStorage/index.js";
import { useSearchProvider } from "../../../../hooks/useSearchProvider/index.js";
import { AVAILABLE_ICONS } from "./constants.js";
import { getCountryCodeFromLocale, getDeliveryLocationSelectorDataProps, setCLocCookie, setC2LocCookie } from "./lib.js";
import { DeliveryLocationSelectorDataSchema } from "./types.js";
const DeliveryLocationSelectorUI = (props) => {
  var _a, _b, _c, _d, _e, _f;
  const {
    hideLabelWhenGRSEnabled,
    isGRSFeatureFlagEnabled,
    isGRSBetaReleaseFeatureFlagEnabled,
    moduleSettings,
    siteSettings,
    isBDPage: isBDPageProp,
    locale,
    isReloadDisabled = false,
    warehouseSpecificDeliveryMethodUIOverridesMap
  } = props;
  const { agent } = useAgent();
  const {
    isInitialized,
    deliveryLocation: bcDeliveryLocation,
    bdDeliveryLocation,
    bdWarehouseNumber,
    warehouse
  } = useBrowseContext();
  const [showSnifferTooltip, setShowSnifferTooltip] = useState(false);
  const [deliveryLocationLocalStorage, setDeliveryLocationLocalStorage] = useLocalStorage(
    DELIVERY_LOCATION_POSTAL_CODE_LOCAL_STORAGE_KEY,
    void 0
  );
  const originalZipCode = Cookie.get(LEGACY_COOKIE_WC_BD_ZIP_ORIGINAL);
  const searchProvider = useSearchProvider({
    isGRSFeatureFlagEnabled,
    isGRSBetaReleaseFeatureFlagEnabled
  });
  const isBDPage = isBDPageProp || isBD();
  const deliveryLocation = isBDPage ? bdDeliveryLocation : bcDeliveryLocation;
  if (isBD()) {
    deliveryLocation.zipCode = (_b = (_a = deliveryLocation.zipCode) == null ? void 0 : _a.replace) == null ? void 0 : _b.call(
      _a,
      "+",
      " "
    );
  }
  const [isDeliveryLocationDrawerOpen, setIsDeliveryLocationDrawerOpen] = useState(false);
  const groceryEligibleRegions = (siteSettings == null ? void 0 : siteSettings.groceryEligibleRegions) || [];
  const countryCode = getCountryCodeFromLocale(locale);
  const data = moduleSettings ? getDeliveryLocationSelectorDataProps(moduleSettings[0]) : {};
  const reloadPageOnDeliveryLocationAutomaticUpdate = data.reloadPageOnAutomaticLocationUpdate && !isReloadDisabled;
  const reloadPageOnDeliveryLocationManualUpdate = data.reloadPageOnManualLocationUpdate && !isReloadDisabled;
  const validationSchemaDeliveryLocation = (_c = DELIVERY_LOCATION_LOCALE_VALIDATION_CONFIGURATION[data.locale]) == null ? void 0 : _c.validationSchema;
  const validationSchemaAkamaiZipCode = (_d = AKAMAI_ZIP_CODE_LOCALE_VALIDATION_CONFIGURATION[data.locale]) == null ? void 0 : _d.validationSchema;
  useEffect(() => {
    if (isInitialized && agent) {
      const updateWarehouseDistributionCenters = async (state, zipCode2) => {
        try {
          const distributionCenterInfo = await (agent == null ? void 0 : agent.getDistributionCenters(state, zipCode2));
          warehouse.updateWarehouse({
            ...distributionCenterInfo
          });
        } catch (err) {
          console.error(err);
        }
      };
      const findFirstValidDeliveryLocation = async () => {
        var _a2;
        let cityToSet;
        let stateToSet;
        let zipCodeToSet;
        let warehouseToSet;
        let countryToSet;
        let shouldReloadPage;
        const {
          warehouse: validatedWarehouse,
          country,
          city,
          state,
          errors
        } = await validateDeliveryLocation(
          agent,
          validationSchemaDeliveryLocation,
          { zipCode: deliveryLocation.zipCode },
          { isBDPage, onlyValidate: true },
          locale
        );
        if (errors) {
          let deliveryLocationValidationErrors;
          const akamaiCookieContent = Cookie.get(AKAMAI_COOKIE);
          if (deliveryLocationLocalStorage && !isBDPage) {
            const {
              warehouse: validatedWarehouse2,
              city: city2,
              state: state2,
              country: country2,
              errors: errors2
            } = await validateDeliveryLocation(
              agent,
              validationSchemaDeliveryLocation,
              { zipCode: deliveryLocationLocalStorage },
              { isBDPage },
              locale
            );
            deliveryLocationValidationErrors = errors2;
            if (!deliveryLocationValidationErrors) {
              cityToSet = city2;
              stateToSet = state2;
              zipCodeToSet = deliveryLocationLocalStorage;
              warehouseToSet = validatedWarehouse2;
              countryToSet = country2;
            }
          } else if (akamaiCookieContent && !isCABD) {
            const decodedValue = decodeURIComponent(akamaiCookieContent);
            const {
              warehouse: validatedWarehouse2,
              city: city2,
              country: country2,
              postalCode,
              state: state2,
              errors: errors2,
              errorConfig
            } = await validateDeliveryLocation(
              agent,
              validationSchemaAkamaiZipCode,
              { zipCode: decodedValue },
              { isBDPage },
              locale
            );
            deliveryLocationValidationErrors = errors2 || errorConfig;
            if (!deliveryLocationValidationErrors) {
              cityToSet = city2;
              stateToSet = state2;
              zipCodeToSet = postalCode;
              warehouseToSet = validatedWarehouse2;
              countryToSet = country2;
              setShowSnifferTooltip(!!isBDPage);
            }
          }
          if (data.defaultLocation && (!zipCodeToSet || deliveryLocationValidationErrors)) {
            const {
              warehouse: validatedWarehouse2,
              city: city2,
              state: state2,
              country: country2,
              errors: errors2
            } = await validateDeliveryLocation(
              agent,
              validationSchemaDeliveryLocation,
              { zipCode: data.defaultLocation },
              { isBDPage },
              locale
            );
            deliveryLocationValidationErrors = errors2;
            if (!deliveryLocationValidationErrors) {
              cityToSet = city2;
              stateToSet = state2;
              zipCodeToSet = data.defaultLocation;
              warehouseToSet = validatedWarehouse2;
              countryToSet = country2;
            }
          }
          if (zipCodeToSet) {
            if (isBD() && typeof zipCodeToSet === "string") {
              zipCodeToSet = zipCodeToSet.trim().replace(" ", "+");
            }
            if (!isBDPage) {
              await updateWarehouseDistributionCenters(
                stateToSet,
                zipCodeToSet
              );
              deliveryLocation.updateDeliveryLocation({
                city: cityToSet || "",
                state: stateToSet || data.defaultState,
                zipCode: zipCodeToSet
              });
              setDeliveryLocationLocalStorage(zipCodeToSet);
              setCLocCookie(countryCode, stateToSet);
              setC2LocCookie(
                countryCode,
                groceryEligibleRegions,
                stateToSet
              );
              shouldReloadPage = true;
            } else {
              if (warehouseToSet) {
                bdWarehouseNumber.updateBdWarehouseNumber(
                  warehouseToSet
                );
              }
              if (zipCode) {
                Cookie.set(
                  LEGACY_COOKIE_WC_BD_LOC,
                  [cityToSet, stateToSet, countryToSet].filter((s) => !!s).join("|")
                );
              }
              deliveryLocation.updateDeliveryLocation({
                zipCode: zipCodeToSet
              });
              shouldReloadPage = true;
            }
          }
        } else {
          if (isBDPage) {
            if (zipCode) {
              Cookie.set(
                LEGACY_COOKIE_WC_BD_LOC,
                [city, state, country].filter((s) => !!s).join("|")
              );
            }
            if (validatedWarehouse && !bdWarehouseNumber.value) {
              bdWarehouseNumber.updateBdWarehouseNumber(
                validatedWarehouse
              );
              shouldReloadPage = true;
            }
          } else {
            if (!((_a2 = warehouse.distributionCenters) == null ? void 0 : _a2.length) && deliveryLocation.zipCode || warehouse.warehouseCookieExpResetFlag() !== "true" && deliveryLocation.zipCode) {
              await updateWarehouseDistributionCenters(
                deliveryLocation.state,
                deliveryLocation.zipCode
              );
              shouldReloadPage = true;
            }
          }
          if (!Cookie.get(C_LOC_COOKIE) && countryCode && deliveryLocation.state) {
            setCLocCookie(countryCode, deliveryLocation.state);
          }
          if (!Cookie.get(C_2LOC_COOKIE) && deliveryLocation.state && groceryEligibleRegions) {
            setC2LocCookie(
              countryCode,
              groceryEligibleRegions,
              deliveryLocation.state
            );
          }
        }
        if (reloadPageOnDeliveryLocationAutomaticUpdate && shouldReloadPage) {
          window.location.reload();
        }
      };
      if (!isBDPage || isBDPage && !deliveryLocation.zipCode) {
        findFirstValidDeliveryLocation();
      }
    }
  }, [
    isInitialized,
    agent,
    reloadPageOnDeliveryLocationAutomaticUpdate,
    setShowSnifferTooltip
  ]);
  useEffect(() => {
    if (!deliveryLocationLocalStorage && deliveryLocation.zipCode) {
      setDeliveryLocationLocalStorage(deliveryLocation.zipCode);
    }
  }, [deliveryLocation.zipCode]);
  try {
    DeliveryLocationSelectorDataSchema.parse(data);
  } catch (err) {
    console.error(err);
    return null;
  }
  let ariaLabel = data.locationSelectorDefault;
  const zipCode = deliveryLocation == null ? void 0 : deliveryLocation.zipCode;
  if (zipCode) {
    ariaLabel = `${data.locationAriaLabelPrefix} ${zipCode}, ${data.locationAriaLabelSuffix}`;
  }
  const showLabel = !(searchProvider === SEARCH_SERVICE_PROVIDERS.GRS && hideLabelWhenGRSEnabled);
  const Icon = AVAILABLE_ICONS[data.iconName || "Box"];
  const tooltipMessage = ((_e = data.akamaiSnifferTooltip) == null ? void 0 : _e.message.replace("{{zipCode}}", zipCode || "").split(data.akamaiSnifferTooltip.delimiter)) || ["", "", ""];
  const TooltipContent = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    tooltipMessage == null ? void 0 : tooltipMessage[0],
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "text-button",
        onClick: () => setIsDeliveryLocationDrawerOpen(true),
        sx: { textDecoration: "underline" },
        children: tooltipMessage == null ? void 0 : tooltipMessage[1]
      }
    ),
    tooltipMessage == null ? void 0 : tooltipMessage[2]
  ] });
  return /* @__PURE__ */ jsxs(
    Analytics,
    {
      analyticData: {
        component: {
          type: "ui"
        },
        trackType: "navigation"
      },
      children: [
        /* @__PURE__ */ jsx(
          LocationSelectorButton,
          {
            onClick: () => {
              setIsDeliveryLocationDrawerOpen(true);
            },
            Icon,
            ariaLabel,
            label: data.locationSelectorLabel,
            showLabel,
            value: originalZipCode || zipCode || data.locationSelectorDefault,
            defaultValue: data.locationSelectorDefault,
            tooltipConfig: {
              showTooltip: showSnifferTooltip,
              Component: /* @__PURE__ */ jsx(
                Tooltip,
                {
                  content: /* @__PURE__ */ jsx(TooltipContent, {}),
                  isOpenByDefault: zipCode && showSnifferTooltip,
                  buttonContent: /* @__PURE__ */ jsx(Icon, {}),
                  buttonAriaLabel: (_f = data.akamaiSnifferTooltip) == null ? void 0 : _f.buttonAriaLabel,
                  tooltipId: "akamai-sniffer",
                  uniqueId: "akamai-sniffer",
                  position: "bottom-start",
                  hasArrow: true,
                  sx: {
                    lineHeight: "170%",
                    ".arrow": {
                      // workaround for tooltip rendering incorrectly on Homepage
                      top: "-2px !important"
                    }
                  }
                }
              )
            },
            uniqueId: "DeliveryLocationSelector"
          }
        ),
        /* @__PURE__ */ jsx(
          DeliveryLocationDrawerUI,
          {
            onSubmit: async ({
              city,
              state,
              zipCode: zipCode2,
              userSelectionDeliveryMethod
            }) => {
              try {
                if (isBDPage && agent) {
                  const validatedDeliveryLocationResp = await validateDeliveryLocation(
                    agent,
                    validationSchemaAkamaiZipCode,
                    { zipCode: zipCode2 },
                    { isBDPage, userSelectionDeliveryMethod },
                    locale
                  );
                  const {
                    warehouse: warehouse2,
                    country,
                    city: city2,
                    state: state2,
                    postalCode,
                    errorConfig
                  } = validatedDeliveryLocationResp || {};
                  if (errorConfig) {
                    return { errorConfig };
                  }
                  if (warehouse2) {
                    bdWarehouseNumber.updateBdWarehouseNumber(
                      warehouse2
                    );
                  }
                  if (zipCode2) {
                    Cookie.set(
                      LEGACY_COOKIE_WC_BD_LOC,
                      [city2, state2, country].filter((s) => !!s).join("|")
                    );
                  }
                  deliveryLocation.updateDeliveryLocation({
                    zipCode: postalCode || ""
                  });
                  if (reloadPageOnDeliveryLocationManualUpdate) {
                    window.location.reload();
                  }
                } else {
                  const distributionCenterInfo = await (agent == null ? void 0 : agent.getDistributionCenters(
                    state,
                    zipCode2
                  ));
                  warehouse.updateWarehouse({
                    ...distributionCenterInfo
                  });
                  deliveryLocation.updateDeliveryLocation({
                    city,
                    state,
                    zipCode: zipCode2
                  });
                  setDeliveryLocationLocalStorage(zipCode2);
                  setCLocCookie(countryCode, state);
                  setC2LocCookie(
                    countryCode,
                    groceryEligibleRegions,
                    state
                  );
                  if (reloadPageOnDeliveryLocationManualUpdate) {
                    window.location.reload();
                  }
                }
              } catch (err) {
                console.error(err);
              }
            },
            agent,
            isOpen: isDeliveryLocationDrawerOpen,
            moduleSettings,
            onClose: () => setIsDeliveryLocationDrawerOpen(false),
            zipCode: zipCode || void 0,
            isBDPage,
            locale,
            warehouseSpecificDeliveryMethodUIOverridesMap
          }
        )
      ]
    }
  );
};
export {
  DeliveryLocationSelectorUI
};
